import * as $runtime from "../runtime.js";
import * as Control$dBind from "../Control.Bind/index.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dArray$dExtra from "../Data.Array.Extra/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dMonoid from "../Data.Monoid/index.js";
import * as Data$dMultiSet from "../Data.MultiSet/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dOrderedMultiSet from "../Data.OrderedMultiSet/index.js";
import * as Data$dRecord from "../Data.Record/index.js";
import * as Data$dSemigroup from "../Data.Semigroup/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dString$dCommon from "../Data.String.Common/index.js";
import * as Data$dTraversable from "../Data.Traversable/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Data$dUUID from "../Data.UUID/index.js";
import * as Data$dUnfoldable from "../Data.Unfoldable/index.js";
import * as Restaumatic$dCalendar$dTypes$dAvailability from "../Restaumatic.Calendar.Types.Availability/index.js";
import * as Restaumatic$dI18n$dTypes from "../Restaumatic.I18n.Types/index.js";
import * as Restaumatic$dLocales from "../Restaumatic.Locales/index.js";
import * as Restaumatic$dMenu$dQuery from "../Restaumatic.Menu.Query/index.js";
import * as Restaumatic$dMenu$dV2$dMenuCatalogue from "../Restaumatic.Menu.V2.MenuCatalogue/index.js";
import * as Restaumatic$dMenu$dV2$dMenuCatalogueQuery from "../Restaumatic.Menu.V2.MenuCatalogueQuery/index.js";
import * as Restaumatic$dMenu$dV2$dParametric from "../Restaumatic.Menu.V2.Parametric/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dItemId from "../Restaumatic.Menu.V2.Types.ItemId/index.js";
const $ProductDetails = (tag, _1) => ({tag, _1});
const intercalate = sep => xs => Data$dFoldable.foldlArray(v => v1 => {
  if (v.init) { return {init: false, acc: v1}; }
  return {init: false, acc: v.acc + sep + v1};
})({init: true, acc: ""})(xs).acc;
const fold = /* #__PURE__ */ (() => Data$dFoldable.foldableArray.foldMap(Data$dMonoid.monoidArray)(Data$dFoldable.identity))();
const foldMap = /* #__PURE__ */ (() => Data$dFoldable.foldableArray.foldMap(Data$dMonoid.monoidString))();
const fromArray = /* #__PURE__ */ Data$dOrderedMultiSet.fromArray(Data$dOrd.ordString);
const toMultiSet = /* #__PURE__ */ Data$dMultiSet.fromOccurArray(Data$dOrd.ordString);
const restoreOrder = /* #__PURE__ */ Data$dOrderedMultiSet.restoreOrder(Data$dEq.eqString);
const difference = /* #__PURE__ */ Data$dMultiSet.difference(Data$dOrd.ordString);
const traverse = /* #__PURE__ */ (() => Data$dTraversable.traversableArray.traverse(Restaumatic$dMenu$dQuery.applicativeMenuQuery))();
const toUnfoldable = /* #__PURE__ */ (() => {
  const $0 = Data$dUnfoldable.unfoldableArray.unfoldr(Data$dMap$dInternal.stepUnfoldr);
  return x => $0(Data$dMap$dInternal.$MapIter("IterNode", x, Data$dMap$dInternal.IterLeaf));
})();
const restoreOrderWith = /* #__PURE__ */ Data$dArray$dExtra.restoreOrderWith(Data$dOrd.ordString);
const for1 = /* #__PURE__ */ (() => {
  const traverse2 = Data$dTraversable.traversableMaybe.traverse(Restaumatic$dMenu$dQuery.applicativeMenuQuery);
  return x => f => traverse2(f)(x);
})();
const for2 = /* #__PURE__ */ (() => {
  const traverse2 = Data$dTraversable.traversableArray.traverse(Restaumatic$dMenu$dQuery.applicativeMenuQuery);
  return x => f => traverse2(f)(x);
})();
const showTranslated = /* #__PURE__ */ Data$dMap$dInternal.showMap(Restaumatic$dLocales.showLocale)(Data$dShow.showString);
const showArray = {show: /* #__PURE__ */ Data$dShow.showArrayImpl(v => "(Tuple " + showTranslated.show(v._1) + " " + Data$dShow.showIntImpl(v._2) + ")")};
const showArray1 = {
  show: /* #__PURE__ */ Data$dShow.showArrayImpl(record => "{ addedItems: " + showArray.show(record.addedItems) + ", includedItems: " + showArray.show(record.includedItems) + ", removedItems: " + showArray.show(record.removedItems) + " " + "}")
};
const showArray2 = {
  show: /* #__PURE__ */ Data$dShow.showArrayImpl(record => "{ choice: " + showTranslated.show(record.choice) + ", parameter: " + showTranslated.show(record.parameter) + " " + "}")
};
const MenuProductDetails = value0 => $ProductDetails("MenuProductDetails", value0);
const MenuComboDetails = value0 => $ProductDetails("MenuComboDetails", value0);
const CustomProductDetails = value0 => $ProductDetails("CustomProductDetails", value0);
const productName = locale => v => {
  if (v.tag === "CustomProductDetails") { return v._1.name; }
  if (v.tag === "MenuProductDetails") { return intercalate(" / ")(Data$dFunctor.arrayMap(x => Restaumatic$dI18n$dTypes.getLocalization(locale)(x.name))(v._1.parts)); }
  if (v.tag === "MenuComboDetails") {
    return intercalate(" + ")(Data$dFunctor.arrayMap(v1 => intercalate(" / ")(Data$dFunctor.arrayMap(x => Restaumatic$dI18n$dTypes.getLocalization(locale)(x.name))(v1.parts)))(v._1));
  }
  $runtime.fail();
};
const productImage = v => {
  if (v.tag === "CustomProductDetails") { return Data$dMaybe.Nothing; }
  if (v.tag === "MenuProductDetails") {
    return Data$dArray.indexImpl(Data$dMaybe.Just, Data$dMaybe.Nothing, Data$dArray.mapMaybe(x => x)(Data$dFunctor.arrayMap(v1 => v1.image)(v._1.parts)), 0);
  }
  if (v.tag === "MenuComboDetails") {
    return Data$dArray.indexImpl(
      Data$dMaybe.Just,
      Data$dMaybe.Nothing,
      Data$dArray.mapMaybe(x => x)(fold(Data$dFunctor.arrayMap(v1 => Data$dFunctor.arrayMap(v2 => v2.image)(v1.parts))(v._1))),
      0
    );
  }
  $runtime.fail();
};
const productFullTextDescription = locale => {
  const renderWithMultiplicity = v => (v._2 > 1 ? Data$dShow.showIntImpl(v._2) + "x " : "") + Restaumatic$dI18n$dTypes.getLocalization(locale)(v._1);
  const renderPart = v => Data$dString$dCommon.joinWith(" / ")(Data$dFunctor.arrayMap(x => Restaumatic$dI18n$dTypes.getLocalization(locale)(x.choice))(v.customParameters)) + foldMap(v1 => foldMap(x => ", " + renderWithMultiplicity(x))(Data$dSemigroup.concatArray(v1.includedItems)(v1.addedItems)))(v.modifiers);
  return v => {
    if (v.tag === "MenuProductDetails") {
      return intercalate(", ")(Data$dSemigroup.concatArray(Data$dFunctor.arrayMap(x => Restaumatic$dI18n$dTypes.getLocalization(locale)(x.choice))(v._1.customParameters))(Data$dFunctor.arrayMap($0 => renderWithMultiplicity($0))(fold(Data$dFunctor.arrayMap(x => Data$dSemigroup.concatArray(x.includedItems)(x.addedItems))(v._1.modifiers))))) + (v._1.parts.length === 1
        ? renderPart(v._1.parts[0])
        : foldMap(part => "; " + Restaumatic$dI18n$dTypes.getLocalization(locale)(part.name) + ": " + renderPart(part))(v._1.parts));
    }
    return "";
  };
};
const parameterDetails = v => {
  const $0 = v._2;
  return Restaumatic$dMenu$dQuery.bindMenuQuery.bind(Restaumatic$dMenu$dV2$dMenuCatalogueQuery.findCustomParameter(v._1))(parameter => Restaumatic$dMenu$dQuery.bindMenuQuery.bind(Restaumatic$dMenu$dQuery.orError(Data$dMap$dInternal.lookup(Data$dOrd.ordString)($0)(parameter.choices._1))(v1 => "Parameter choice not found"))(choice => Restaumatic$dMenu$dQuery.applicativeMenuQuery.pure({
    parameter: Data$dRecord.unsafeGet("name")(parameter),
    choice: Data$dRecord.unsafeGet("name")(choice)
  })));
};
const modifierDetails = menuEnv => v => {
  const $0 = v._2;
  return Restaumatic$dMenu$dQuery.bindMenuQuery.bind(Restaumatic$dMenu$dV2$dMenuCatalogueQuery.findModifier(v._1))(modifier => {
    const items = Restaumatic$dMenu$dV2$dMenuCatalogue.fold(Data$dFunctor.arrayMap(x => x.items)(Data$dRecord.unsafeGet("sections")(modifier)));
    const displayItem = v1 => {
      const $1 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(v1._1)(items._1);
      if ($1.tag === "Just") { return Data$dMaybe.$Maybe("Just", Data$dTuple.$Tuple(Data$dRecord.unsafeGet("name")($1._1), v1._2)); }
      return Data$dMaybe.Nothing;
    };
    const defaultItems = modifier.exchangePolicy.tag === "NotIncluded" ? [] : Restaumatic$dMenu$dV2$dMenuCatalogue.modifierDefaultChoices(modifier);
    const defaultItemsSet = toMultiSet(defaultItems);
    const includedItems = restoreOrder(defaultItems)(Data$dMap$dInternal.unsafeIntersectionWith(Data$dOrd.ordString.compare, Data$dMultiSet.min, defaultItemsSet, $0));
    const removedItems = restoreOrder(defaultItems)(difference(defaultItemsSet)($0));
    const addedItems = restoreOrder(fromArray(Data$dFunctor.arrayMap(Data$dTuple.fst)(items._2)))(difference($0)(defaultItemsSet));
    return Restaumatic$dMenu$dQuery.applicativeMenuQuery.pure((() => {
      const $1 = Data$dRecord.unsafeGet("displayMode")(modifier);
      return Restaumatic$dMenu$dV2$dParametric.isParametricPossibleBoole.isPossible(Data$dRecord.unsafeGet("availableWhen")(modifier))(Restaumatic$dMenu$dV2$dParametric.fromInternalParameterValues(menuEnv.params)) && (
        $1.tag === "ModifierList" || $1.tag === "ModifierCheckboxList" || $1.tag === "ModifierRadioButtonList" || $1.tag === "ModifierPizzaGrid" || !($1.tag === "ModifierHidden")
      );
    })()
      ? Data$dMaybe.$Maybe(
          "Just",
          {
            removedItems: Data$dArray.mapMaybe(x => x)(Data$dFunctor.arrayMap(displayItem)(removedItems)),
            addedItems: Data$dArray.mapMaybe(x => x)(Data$dFunctor.arrayMap(displayItem)(addedItems)),
            includedItems: Data$dArray.mapMaybe(x => x)(Data$dFunctor.arrayMap(displayItem)(includedItems))
          }
        )
      : Data$dMaybe.Nothing);
  });
};
const partDetails = menuEnv => v => {
  const $0 = v.customParameters;
  const $1 = v.modifiers;
  return Restaumatic$dMenu$dQuery.bindMenuQuery.bind(Restaumatic$dMenu$dV2$dMenuCatalogueQuery.findProduct(v.productId))(product => Restaumatic$dMenu$dQuery.bindMenuQuery.bind(traverse(parameterDetails)(toUnfoldable($0)))(customParametersDetailsVal => Restaumatic$dMenu$dQuery.bindMenuQuery.bind(Restaumatic$dMenu$dQuery.functorMenuQuery.map(Data$dArray.catMaybes)(traverse(modifierDetails(menuEnv))(restoreOrderWith(Data$dTuple.fst)(Data$dRecord.unsafeGet("divisibleModifiersOrder")(product))(toUnfoldable($1)))))(modifierDetailsVal => Restaumatic$dMenu$dQuery.bindMenuQuery.bind(for1(product.availabilitySchedule)(Restaumatic$dMenu$dV2$dMenuCatalogueQuery.findAvailabilitySchedule))(availabilityMb => Restaumatic$dMenu$dQuery.applicativeMenuQuery.pure({
    customParameters: customParametersDetailsVal,
    modifiers: modifierDetailsVal,
    image: (() => {
      const $2 = Data$dRecord.unsafeGet("photo")(product);
      if ($2.tag === "Just") { return Data$dMaybe.$Maybe("Just", $2._1); }
      return Data$dMaybe.Nothing;
    })(),
    name: Data$dRecord.unsafeGet("name")(product),
    availability: availabilityMb.tag === "Just" ? Data$dMaybe.$Maybe("Just", availabilityMb._1.availability) : Data$dMaybe.Nothing
  })))));
};
const menuProductDetails = menuEnv => v => {
  const $0 = v.customParameters;
  const $1 = v.modifiers;
  const $2 = v.parts;
  const $3 = Data$dArray.indexImpl(Data$dMaybe.Just, Data$dMaybe.Nothing, $2, 0);
  const productId = (() => {
    if ($3.tag === "Just") { return $3._1.productId; }
    $runtime.fail();
  })();
  return Restaumatic$dMenu$dQuery.bindMenuQuery.bind(Restaumatic$dMenu$dV2$dMenuCatalogueQuery.findProduct(productId))(product => Restaumatic$dMenu$dQuery.bindMenuQuery.bind(traverse(x => Restaumatic$dMenu$dV2$dMenuCatalogueQuery.findProduct(Data$dRecord.unsafeGet("productId")(x)))(Data$dArray.fromFoldableImpl(
    Data$dFoldable.foldrArray,
    $2
  )))(products => {
    const modifierOrder = Data$dArray.nubBy(Data$dOrd.ordString.compare)(Control$dBind.arrayBind(products)(v1 => Data$dRecord.unsafeGet("nonDivisibleModifiersOrder")(v1)));
    return Restaumatic$dMenu$dQuery.bindMenuQuery.bind(traverse(parameterDetails)(toUnfoldable($0)))(customParametersDetailsVal => Restaumatic$dMenu$dQuery.bindMenuQuery.bind(Restaumatic$dMenu$dQuery.functorMenuQuery.map(Data$dArray.catMaybes)(traverse(modifierDetails(menuEnv))(restoreOrderWith(Data$dTuple.fst)(modifierOrder)(toUnfoldable($1)))))(modifierDetailsVal => Restaumatic$dMenu$dQuery.bindMenuQuery.bind(traverse(x => partDetails(menuEnv)(x))(Data$dArray.fromFoldableImpl(
      Data$dFoldable.foldrArray,
      $2
    )))(partDetailsVal => Restaumatic$dMenu$dQuery.applicativeMenuQuery.pure({
      customParameters: customParametersDetailsVal,
      modifiers: modifierDetailsVal,
      parts: partDetailsVal,
      productCategoryId: Data$dRecord.unsafeGet("category")(product),
      itemId: Restaumatic$dMenu$dV2$dTypes$dItemId.$ItemId("ProductItem", productId),
      customParametersMap: $0
    }))));
  }));
};
const menuComboDetails = menuEnv => v => {
  const $0 = v.comboId;
  const $1 = v.elements;
  return Restaumatic$dMenu$dQuery.bindMenuQuery.bind(Restaumatic$dMenu$dV2$dMenuCatalogueQuery.findCombo($0))(combo => Restaumatic$dMenu$dQuery.functorMenuQuery.map(Data$dArray.catMaybes)(for2(combo.elements._2)(v1 => {
    const v2 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(v1._1)($1);
    if (v2.tag === "Nothing") { return Restaumatic$dMenu$dQuery.applicativeMenuQuery.pure(Data$dMaybe.Nothing); }
    if (v2.tag === "Just") {
      const $2 = v2._1.customParameters;
      const $3 = v2._1.modifiers;
      return Restaumatic$dMenu$dQuery.bindMenuQuery.bind(Restaumatic$dMenu$dQuery.orError(Data$dMap$dInternal.lookup(Data$dOrd.ordString)(v2._1.comboChoiceId)(v1._2.choices._1))(v3 => "Combo choice not found"))(choice => {
        const productId = choice.product;
        return Restaumatic$dMenu$dQuery.bindMenuQuery.bind(Restaumatic$dMenu$dV2$dMenuCatalogueQuery.findProduct(productId))(product => Restaumatic$dMenu$dQuery.bindMenuQuery.bind(traverse(parameterDetails)(toUnfoldable($2)))(customParametersDetailsVal => Restaumatic$dMenu$dQuery.bindMenuQuery.bind(Restaumatic$dMenu$dQuery.functorMenuQuery.map(Data$dArray.catMaybes)(traverse(modifierDetails(menuEnv))(restoreOrderWith(Data$dTuple.fst)(Data$dRecord.unsafeGet("nonDivisibleModifiersOrder")(product))(toUnfoldable($3)))))(modifierDetailsVal => Restaumatic$dMenu$dQuery.bindMenuQuery.bind(partDetails(menuEnv)({
          customParameters: $2,
          modifiers: $3,
          productId
        }))(partDetailsVal => Restaumatic$dMenu$dQuery.applicativeMenuQuery.pure(Data$dMaybe.$Maybe(
          "Just",
          {
            customParameters: customParametersDetailsVal,
            modifiers: modifierDetailsVal,
            parts: [partDetailsVal],
            productCategoryId: product.category,
            itemId: Restaumatic$dMenu$dV2$dTypes$dItemId.$ItemId("ComboItem", $0),
            customParametersMap: $2
          }
        ))))));
      });
    }
    $runtime.fail();
  })));
};
const productDetails = menuEnv => v => {
  if (v.tag === "CustomProduct") {
    return Restaumatic$dMenu$dQuery.applicativeMenuQuery.pure($ProductDetails("CustomProductDetails", {name: Data$dRecord.unsafeGet("name")(v._1)}));
  }
  if (v.tag === "MenuProduct") { return Restaumatic$dMenu$dQuery.functorMenuQuery.map(MenuProductDetails)(menuProductDetails(menuEnv)(v._1)); }
  if (v.tag === "MenuCombo") { return Restaumatic$dMenu$dQuery.functorMenuQuery.map(MenuComboDetails)(menuComboDetails(menuEnv)(v._1)); }
  $runtime.fail();
};
const genericProductDetails = {
  to: x => {
    if (x.tag === "Inl") { return $ProductDetails("MenuProductDetails", x._1); }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return $ProductDetails("MenuComboDetails", x._1._1); }
      if (x._1.tag === "Inr") { return $ProductDetails("CustomProductDetails", x._1._1); }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "MenuProductDetails") { return Data$dGeneric$dRep.$Sum("Inl", x._1); }
    if (x.tag === "MenuComboDetails") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)); }
    if (x.tag === "CustomProductDetails") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", x._1)); }
    $runtime.fail();
  }
};
const showProductDetails = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dShow.showArrayImpl(record => {
        if (record.availability.tag === "Just") {
          return "{ availability: (Just " + Restaumatic$dCalendar$dTypes$dAvailability.showWeeklyAvailability.show(record.availability._1) + ")" + ", customParameters: " + showArray2.show(record.customParameters) + (() => {
            if (record.image.tag === "Just") {
              return ", image: (Just " + Data$dShow.showStringImpl(record.image._1) + ")" + ", modifiers: " + showArray1.show(record.modifiers) + ", name: " + showTranslated.show(record.name) + " ";
            }
            if (record.image.tag === "Nothing") {
              return ", image: Nothing, modifiers: " + showArray1.show(record.modifiers) + ", name: " + showTranslated.show(record.name) + " ";
            }
            $runtime.fail();
          })() + "}";
        }
        if (record.availability.tag === "Nothing") {
          return "{ availability: Nothing, customParameters: " + showArray2.show(record.customParameters) + (() => {
            if (record.image.tag === "Just") {
              return ", image: (Just " + Data$dShow.showStringImpl(record.image._1) + ")" + ", modifiers: " + showArray1.show(record.modifiers) + ", name: " + showTranslated.show(record.name) + " ";
            }
            if (record.image.tag === "Nothing") {
              return ", image: Nothing, modifiers: " + showArray1.show(record.modifiers) + ", name: " + showTranslated.show(record.name) + " ";
            }
            $runtime.fail();
          })() + "}";
        }
        $runtime.fail();
      });
      const $1 = Data$dMap$dInternal.showMap(Data$dUUID.showUUID)(Data$dUUID.showUUID);
      return {
        genericShowArgs: v => [
          "{ customParameters: " + showArray2.show(v.customParameters) + ", customParametersMap: " + $1.show(v.customParametersMap) + ", itemId: " + Restaumatic$dMenu$dV2$dTypes$dItemId.showItemId.show(v.itemId) + ", modifiers: " + showArray1.show(v.modifiers) + ", parts: " + $0(v.parts) + ", productCategoryId: " + v.productCategoryId + " " + "}"
        ]
      };
    })())({reflectSymbol: () => "MenuProductDetails"});
    const $1 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $1 = Data$dShow.showArrayImpl(record => {
        if (record.availability.tag === "Just") {
          return "{ availability: (Just " + Restaumatic$dCalendar$dTypes$dAvailability.showWeeklyAvailability.show(record.availability._1) + ")" + ", customParameters: " + showArray2.show(record.customParameters) + (() => {
            if (record.image.tag === "Just") {
              return ", image: (Just " + Data$dShow.showStringImpl(record.image._1) + ")" + ", modifiers: " + showArray1.show(record.modifiers) + ", name: " + showTranslated.show(record.name) + " ";
            }
            if (record.image.tag === "Nothing") {
              return ", image: Nothing, modifiers: " + showArray1.show(record.modifiers) + ", name: " + showTranslated.show(record.name) + " ";
            }
            $runtime.fail();
          })() + "}";
        }
        if (record.availability.tag === "Nothing") {
          return "{ availability: Nothing, customParameters: " + showArray2.show(record.customParameters) + (() => {
            if (record.image.tag === "Just") {
              return ", image: (Just " + Data$dShow.showStringImpl(record.image._1) + ")" + ", modifiers: " + showArray1.show(record.modifiers) + ", name: " + showTranslated.show(record.name) + " ";
            }
            if (record.image.tag === "Nothing") {
              return ", image: Nothing, modifiers: " + showArray1.show(record.modifiers) + ", name: " + showTranslated.show(record.name) + " ";
            }
            $runtime.fail();
          })() + "}";
        }
        $runtime.fail();
      });
      const $2 = Data$dMap$dInternal.showMap(Data$dUUID.showUUID)(Data$dUUID.showUUID);
      const $3 = Data$dShow.showArrayImpl(record => "{ customParameters: " + showArray2.show(record.customParameters) + ", customParametersMap: " + $2.show(record.customParametersMap) + ", itemId: " + Restaumatic$dMenu$dV2$dTypes$dItemId.showItemId.show(record.itemId) + ", modifiers: " + showArray1.show(record.modifiers) + ", parts: " + $1(record.parts) + ", productCategoryId: " + record.productCategoryId + " " + "}");
      return {genericShowArgs: v => [$3(v)]};
    })())({reflectSymbol: () => "MenuComboDetails"});
    const $2 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => ["{ name: " + Data$dShow.showStringImpl(v.name) + " }"]})({
      reflectSymbol: () => "CustomProductDetails"
    });
    return x => {
      const $3 = genericProductDetails.from(x);
      if ($3.tag === "Inl") { return $0["genericShow'"]($3._1); }
      if ($3.tag === "Inr") {
        if ($3._1.tag === "Inl") { return $1["genericShow'"]($3._1._1); }
        if ($3._1.tag === "Inr") { return $2["genericShow'"]($3._1._1); }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
export {
  $ProductDetails,
  CustomProductDetails,
  MenuComboDetails,
  MenuProductDetails,
  difference,
  fold,
  foldMap,
  for1,
  for2,
  fromArray,
  genericProductDetails,
  intercalate,
  menuComboDetails,
  menuProductDetails,
  modifierDetails,
  parameterDetails,
  partDetails,
  productDetails,
  productFullTextDescription,
  productImage,
  productName,
  restoreOrder,
  restoreOrderWith,
  showArray,
  showArray1,
  showArray2,
  showProductDetails,
  showTranslated,
  toMultiSet,
  toUnfoldable,
  traverse
};
